import LoadingMask from './LoadingMask';

export default LoadingMask;
